// /TBS/frontend/src/routes/ApplicantRoute.jsx
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import API from "../helpers/API";
import Spinner from "../ui/Spinner/Spinner";
import AuthLoader from "../ui/Loader/AuthLoader";

export const ApplicantRoute = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const authContext = useAuth();
  const [auth, setAuth] = authContext;
  const { isAuthenticated, isInitialized, clearAuth } = authContext;
  const navigate = useNavigate();
  const isCheckingRef = useRef(false);
  const hasCheckedRef = useRef(false);

  const checkAuthorization = useCallback(async () => {
    if (!isInitialized) return;

    if (isCheckingRef.current) return;

    if (!isAuthenticated) {
      setIsAuthorized(false);
      setIsLoading(false);
      hasCheckedRef.current = true;
      navigate("/Login", { replace: true });
      return;
    }

    isCheckingRef.current = true;

    try {
      const res = await API.get("/auth/applicantRoute");
      const isValid = res.data && res.data.ok === true;
      setIsAuthorized(isValid);

      if (!isValid) {
        clearAuth();
        navigate("/Login", { replace: true });
      }
    } catch (error) {
      setIsAuthorized(false);
      if (error.response?.status === 401) {
        clearAuth();
        navigate("/Login", { replace: true });
      } else if (error.response?.status === 403) {
        navigate("/Login", { replace: true });
      }
    } finally {
      setIsLoading(false);
      isCheckingRef.current = false;
      hasCheckedRef.current = true;
    }
  }, [isAuthenticated, isInitialized, auth.user?.email, navigate, clearAuth]);

  useEffect(() => {
    if (isInitialized && (!hasCheckedRef.current || !isAuthenticated)) {
      hasCheckedRef.current = false;
      checkAuthorization();
    }
  }, [isInitialized, isAuthenticated, checkAuthorization]);

  useEffect(() => {
    return () => {
      isCheckingRef.current = false;
      hasCheckedRef.current = false;
    };
  }, []);

  if (!isInitialized || isLoading) {
    return <AuthLoader />;
  }

  if (!isAuthenticated) {
    return <Spinner path="/Login" />;
  }

  return isAuthorized ? <Outlet /> : <Spinner path="/Login" />;
};
